import StackedBarChart from '@global/StackedBarChart'
import { COLORS } from '@styles/colors'
import { Container, Section } from '@styles/global.styled'
import StatisticItems from '../StatisticItems'
import { OverviewContainer } from './SalesOverview.styled'

const daysToYears = (days) => {
  if (!days) return null
  if (days >= 365) {
    return `${Math.round(days / 365)} years`
  }
  return `${days} days`
}

const SaleOverview = ({ suburb, salesOverview }) => {
  const investerStatisticsData = [
    {
      title: 'Average days on market (houses)',
      subTitle: '(all agencies, 12 months)',
      value: salesOverview?.house?.avg_days_on_market || null,
    },
    {
      title: 'Average days on market (units)',
      subTitle: '(all agencies, 12 months)',
      value: salesOverview?.unit?.avg_days_on_market || null,
    },
    {
      title: `Auction clearance rate in ${suburb}`,
      subTitle: '(all agencies, last 12 months)',
      value: salesOverview?.auction_clearance_rate
        ? `${salesOverview.auction_clearance_rate}%`
        : null,
    },
    {
      title: `Average held period in ${suburb}`,
      subTitle: '(proptrack)',
      value: salesOverview?.avg_held_period
        ? daysToYears(salesOverview.avg_held_period)
        : null,
    },
  ]

  const isShowData =
    salesOverview?.auction_pct ||
    salesOverview?.priv_and_unknown_pct ||
    investerStatisticsData.filter((it) => it.value).length

  if (!isShowData) return null
  return (
    <Section withPaddingBottom>
      <Container>
        <OverviewContainer>
          <StackedBarChart
            alwaysShowTitle
            title={`${suburb.toUpperCase()} SALES OVERVIEW`}
            data={[
              {
                label: 'Sold by Auction',
                value: salesOverview?.auction_pct,
                color: COLORS.secondary,
              },
              {
                label: 'Sold by Private Sale or Other Method',
                value: salesOverview?.priv_and_unknown_pct,
                color: COLORS.cobalt[70],
              },
            ].filter((item) => item.value > 0)}
            note='(Based on Sales Reported in the Last 12 Months)'
          />
          <StatisticItems
            statistics={investerStatisticsData.filter((it) => it.value)}
          />
        </OverviewContainer>
      </Container>
    </Section>
  )
}

export default SaleOverview
